let maxPriceSelect = document.getElementById("maxPrice");
let minPriceSelect = document.getElementById("minPrice");

let maxLengthSelect = document.getElementById("maxLength");
let minLengthSelect = document.getElementById("minLength");

function greaterThanOrEqual(a, b) {
	return Number(a) >= Number(b);
}

function lessThanOrEqual(a, b) {
	return Number(a) <= Number(b);
}

export function init() {
	if (document.querySelector(".c-searchbox")) {
		minPriceSelect.addEventListener("change", (event) => {
			disableOptions(event, maxPriceSelect, greaterThanOrEqual);
		});

		maxPriceSelect.addEventListener("change", (event) => {
			disableOptions(event, minPriceSelect, lessThanOrEqual);
		});

		minLengthSelect.addEventListener("change", (event) => {
			disableOptions(event, maxLengthSelect, greaterThanOrEqual);
		});

		maxLengthSelect.addEventListener("change", (event) => {
			disableOptions(event, minLengthSelect, lessThanOrEqual);
		});

		// document.addEventListener('DOMContentLoaded', disablePriceOptions);
		// minLengthSelect.addEventListener('change', disableLengthOptions);
		// document.addEventListener('DOMContentLoaded', disableLengthOptions);

		function disableOptions(event, dependentSelect, comparisonFn) {
			let target = event.currentTarget;
			let targetValue = target.options[target.selectedIndex].value;
			let dependentValue =
				dependentSelect.options[dependentSelect.selectedIndex].value;

			let dependentOptions = Array.from(dependentSelect.options);

			dependentOptions.forEach(function (opt) {
				if (opt.value == "" || targetValue == "") {
					opt.disabled = false;
				} else {
					opt.disabled = comparisonFn(targetValue, opt.value);
				}
			});

			// compare targetValue and dependentValue
			if (comparisonFn(dependentValue, targetValue)) {
				return;
			}

			for (let i = 0; i < dependentSelect.options.length; i++) {
				let option = dependentSelect.options[i];

				if (!option.disabled && targetValue != "") {
					dependentSelect.selectedIndex = i;
					return;
				}
			}
		}
	}
}
